const MODEL_NAME_THRESHOLD = 99

/** Compact number formatting: 700000 → "700k", 1500 → "1.5k" */
export function abbreviateCount(count: number): string {
  if (count < 1000) return String(count)

  if (count < 1_000_000) {
    const thousands = count / 1000
    if (thousands >= 100) return `${Math.floor(thousands)}k`
    if (thousands >= 10) return `${Math.round(thousands)}k`
    const rounded = Math.round(thousands * 10) / 10
    return `${rounded % 1 === 0 ? rounded.toFixed(0) : rounded}k`
  }

  const millions = count / 1_000_000
  if (millions >= 100) return `${Math.floor(millions)}M`
  if (millions >= 10) return `${Math.round(millions)}M`
  const rounded = Math.round(millions * 10) / 10
  return `${rounded % 1 === 0 ? rounded.toFixed(0) : rounded}M`
}

export function formatViewSelectorCountLabel(
  total: number | undefined,
  modelName: string | undefined,
  options: { showFullCount?: boolean } = {},
): string {
  const name = modelName || 'Records'

  if (total === undefined) {
    return name
  }

  const showModelName = total <= MODEL_NAME_THRESHOLD
  const countStr = options.showFullCount
    ? String(total)
    : abbreviateCount(total)

  if (showModelName) {
    return `${countStr} ${name}`
  }

  return countStr
}
